import { ResourceKind } from 'lib/enum/resource-kind.enum';
import { generateIri } from 'lib/utils/iri';
import { JobGroup, privateApi } from 'services';
import { JobGroupCollectionOutput } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const fetchJobGroups = async (businessAccountId: string): Promise<JobGroupCollectionOutput[]> =>
    privateApi.get<JobGroupCollectionOutput[]>(`business-accounts/${businessAccountId}/job-groups`);

const createJobGroup = async (
    name: string,
    businessAccountId: string,
    budgetNotificationEmails: string[] = [],
): Promise<JobGroupCollectionOutput> =>
    privateApi.post<JobGroupCollectionOutput>('job-groups', {
        name,
        businessAccount: generateIri(ResourceKind.BusinessAccount, businessAccountId),
        budgetNotificationEmails,
    });

const updateJobGroup = async (
    id: string,
    updatedJobGroupFields: Partial<JobGroupCollectionOutput>,
): Promise<JobGroup> => privateApi.put<JobGroup>(`job-groups/${id}`, updatedJobGroupFields);

const archiveJobGroup = async (id: string): Promise<JobGroup> => privateApi.post<JobGroup>(`job-groups/${id}/archive`);

const unarchiveJobGroup = async (id: string): Promise<JobGroup> =>
    privateApi.post<JobGroup>(`job-groups/${id}/unarchive`);

export const JobGroupCollectionOutputGateway = {
    fetchJobGroups,
    createJobGroup,
    updateJobGroup,
    archiveJobGroup,
    unarchiveJobGroup,
};

const cancelableFetchJobGroups = async (businessAccountId: string): Promise<JobGroupCollectionOutput[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<JobGroupCollectionOutput[]>(
        `business-accounts/${businessAccountId}/job-groups`,
    );

export const CancelableJobGroupCollectionOutputGateway = {
    cancelableFetchJobGroups,
};
